/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Nav_PricingInputs */

const en_zombie_nav_pricing = /** @type {(inputs: Zombie_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_zombie_nav_pricing = /** @type {(inputs: Zombie_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Zombie_Nav_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_nav_pricing = /** @type {((inputs?: Zombie_Nav_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Nav_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_nav_pricing(inputs)
	return zh_zombie_nav_pricing(inputs)
});
export { zombie_nav_pricing as "zombie.nav.pricing" }